import { Component, ViewChild } from '@angular/core';
import { IChangePassword } from '@core/apis/patient/patient.interface';
import { UserApi } from '@core/apis/user/user.api';
import { ChangePasswordModalComponent } from '@core/components/change-password-modal/change-password-modal.component';
import { DashboardComponent } from '@core/components/dashboard/dashboard.component';
import { IUserStore } from '@core/interfaces/interface';
import { UserStore } from '@core/stores/user.store';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { navigationClinic } from '../../navigation';
import { UserTypeEnum } from '@oranta-mis/sdk';

@Component({
  selector: 'app-clinic-home',
  standalone: true,
  imports: [DashboardComponent, TranslocoModule, ChangePasswordModalComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
})
@UntilDestroy()
export class ClinicHomeComponent {
  protected readonly clinicHomeIconsList = navigationClinic.slice(1);
  public user: IUserStore | null = null;
  public isLoading: boolean = false;

  public readonly UserTypeEnum = UserTypeEnum;

  @ViewChild(ChangePasswordModalComponent)
  orderModal!: ChangePasswordModalComponent;
  constructor(
    private readonly userStore: UserStore,
    private readonly userApi: UserApi,
  ) {}

  public ngOnInit(): void {
    this.user = this.userStore.get();
  }

  public changePasswordModal() {
    this.orderModal.openModal();
  }

  public changePassword(form: IChangePassword) {
    this.userApi
      .changePassword(form)
      .pipe(untilDestroyed(this))
      .subscribe({
        complete: () => {
          this.isLoading = false;
          this.orderModal.closeDialogModal();
        },
      });
  }
}
